export interface IPhoneConfirmationStartRequest {
    sessionId: string | null,
    phone: string,
    channel: string,
    hCaptchaToken: string | null
}

export class PhoneConfirmationStartRequest implements IPhoneConfirmationStartRequest {
    sessionId: string | null = null;
    phone: string = '';
    channel: string = '';
    hCaptchaToken: string | null = null;
}
